import React from "react";
import { Box, Button, MenuItem, Select, TextField } from "@mui/material";
import { AddRounded } from "@mui/icons-material";
import { ActiveResponse } from "../../../services/decisionFlow";
import { AdminFilterBar, AdminPageHeader, AppModal, DataTable, EmptyState, countLabel } from "../../../components/ui";
import { StatusFilter, useManageActives } from "./use-manage-actives";
import { buildActivesColumns } from "./actives-columns";

export const ManageActives: React.FC = () => {
    const {
        state,
        actives,
        modalName,
        setModalName,
        search,
        setSearch,
        statusFilter,
        setStatusFilter,
        filteredRows,
        isEditing,
        handlePageChange,
        handlePageSizeChange,
        handleEnableActive,
        handleNewActive,
        openCreate,
        openEdit,
        closeModal,
    } = useManageActives();

    const columns = buildActivesColumns({ onToggle: handleEnableActive, onEdit: openEdit });
    const total = actives.pagination.total;

    return (
        <Box sx={{ width: "100%", p: { xs: "18px 16px 24px", md: 4 } }}>
            <AdminPageHeader
                title="Gestão de Classes"
                subtitle="Classes de ativos do catálogo."
                action={
                    <Button
                        variant="contained"
                        startIcon={<AddRounded />}
                        onClick={openCreate}
                        sx={{ height: 44, borderRadius: "12px", fontWeight: 600 }}
                    >
                        Novo ativo
                    </Button>
                }
            />

            <AdminFilterBar
                search={search}
                onSearch={setSearch}
                placeholder="Buscar por nome..."
                filters={
                    <Select
                        size="small"
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value as StatusFilter)}
                        sx={{ height: 44, minWidth: 140, borderRadius: "10px" }}
                    >
                        <MenuItem value="all">Todos</MenuItem>
                        <MenuItem value="enabled">Ativo</MenuItem>
                        <MenuItem value="disabled">Inativo</MenuItem>
                    </Select>
                }
                count={countLabel(filteredRows.length, total)}
            />

            <DataTable<ActiveResponse>
                columns={columns}
                rows={filteredRows}
                rowKey={(row) => String(row.id)}
                page={actives.pagination.currentPage}
                pageSize={actives.pagination.perPage}
                totalRows={actives.pagination.total}
                onPageChange={handlePageChange}
                onPageSizeChange={handlePageSizeChange}
                countLabel={countLabel(filteredRows.length, total)}
                emptyState={<EmptyState title="Nenhuma classe encontrada" description="Crie uma nova classe para começar." />}
            />

            <AppModal
                open={state.open}
                onClose={closeModal}
                kicker={isEditing ? "Editar" : "Cadastrar"}
                title={isEditing ? "Editar classe" : "Nova classe"}
                maxWidth={440}
                footer={
                    <>
                        <Button variant="outlined" onClick={closeModal} sx={{ height: 40, borderRadius: "10px" }}>
                            Cancelar
                        </Button>
                        <Button
                            variant="contained"
                            onClick={() => handleNewActive(modalName, state.active?.id)}
                            sx={{ height: 40, borderRadius: "10px" }}
                        >
                            Salvar
                        </Button>
                    </>
                }
            >
                <TextField fullWidth label="Nome do ativo" variant="outlined" value={modalName} onChange={(e) => setModalName(e.target.value)} autoFocus />
            </AppModal>
        </Box>
    );
};
